




import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import TimesheetStatus from '@/models/Timesheets/TimesheetStatus';
import StatusDisplayLocation from '@/models/Shared/StatusDisplayLocation';

@Component({
  name: 'BookingRoleStatus',
})
export default class extends GiganautVue {

	@Prop({required: true})
	status: TimesheetStatus;

	@Prop({required: true})
	location: StatusDisplayLocation;
	
	get textColor() {
		let color = "orange--text";
		switch (this.status) {
			case TimesheetStatus.Pending:
				color = "orange--text";
				break;
			case TimesheetStatus.Approved:
				color = "green--text";
				break;
			case TimesheetStatus.Cancelled:
				color = "red--text";
				break;
			default:
				color = "orange-text";
				break;
		}
		return color;
	}

	get text() {
		let text = "";
		switch (this.status) {
			case TimesheetStatus.Pending:
				text = "PENDING";
				break;
			case TimesheetStatus.Approved:
				text = "APPROVED";
				break;
			case TimesheetStatus.Cancelled:
				text = "CANCELLED";
				break;
			default:
				text = "UNKNOWN STATUS"
				break;
		}
		return text;
	}
	
	get classy() {
		const classes: string[] = [this.textColor]
		switch (this.location) {
			case StatusDisplayLocation.Title:
				classes.push("overline");
				classes.push("ma-2");
				break;
			case StatusDisplayLocation.SubTitle:
				classes.push("overline");
				classes.push("mr-2");
				break;
			case StatusDisplayLocation.Grid:
				classes.push("overline");
				classes.push("mr-2");
				break;
			default:
				classes.push("overline");
				classes.push("ma-2");
				break;
		}
		return classes;
	}
}
